import React from 'react'
import { Switch } from 'react-router-dom'

import { AuthRoute, GuestRoute } from '../../common/components/routes'
import { APP_ROUTES } from '../../common/constants'

import {
  EmailLoginPage,
  LoginPage,
  LogoutPage,
  UserSettingsPage,
} from './pages'

const AccountRouter = () => (
  <Switch>
    <GuestRoute path={APP_ROUTES.LOGIN.link} component={LoginPage} />
    <GuestRoute path={APP_ROUTES.LOGIN_EMAIL.link} component={EmailLoginPage} />
    <AuthRoute path={APP_ROUTES.SETTINGS.link} component={UserSettingsPage} />
    <AuthRoute path={APP_ROUTES.LOGOUT.link} component={LogoutPage} />
  </Switch>
)

export default AccountRouter
